/**
 * Measurements helper — basic validation, persists to sessionStorage so a
 * customer who navigates between products doesn't have to retype.
 */
(function () {
  const KEY = 'african-fashion:measurements';

  function load() {
    try { return JSON.parse(sessionStorage.getItem(KEY) || '{}'); }
    catch { return {}; }
  }

  function save(data) {
    sessionStorage.setItem(KEY, JSON.stringify(data));
  }

  document.addEventListener('DOMContentLoaded', () => {
    const stored = load();
    document.querySelectorAll('[data-measurements] input, [data-measurements] textarea').forEach((el) => {
      const m = el.name.match(/properties\[(.+?)\]/);
      if (!m) return;
      if (stored[m[1]]) el.value = stored[m[1]];

      el.addEventListener('change', () => {
        const data = load();
        data[m[1]] = el.value;
        save(data);
      });
    });
  });
})();
